module.exports = __webpack_public_path__ + "img/grid-dots-left.41cd77da.svg";